import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import optionTypes from '../constants/option-types';
import ElementSettingsContext from '../helpers/element-settings-context';
import getOptionAttributesValues from '../helpers/get-option-attributes-values';

const { Heading, Box, SimpleSelect, HorizontalStack, InfoWithPopover } = designSystem;

const SelectOption = ({ option, settingId, onUpdateValue }) => {
  const { state, callbacks, updateState } = useContext(ElementSettingsContext);
  const attributesValues = getOptionAttributesValues(state, option);

  const currentValue = attributesValues[0];

  const adaptedOptions = option.choices.map((el) => ({
    label: el.name,
    value: el.value,
  }));

  const defaultValue = adaptedOptions.find((el) => el.value === currentValue) || adaptedOptions[0];

  const paddingProps = {
    paddingBottom: 'spacing-xs',
    paddingLeft: 'spacing-m',
    paddingRight: 'spacing-m',
  };

  const handleSelectChange = (value) => {
    const { onChange } = option;
    let additionalBatch;
    if (onChange) {
      additionalBatch = onChange(value.value, option, updateState);
    }

    onUpdateValue(value.value, additionalBatch, option.attributes);
    callbacks.onOptionClicked({ optionId: option.id, settingId });
  };

  return (
    <Box {...paddingProps}>
      <HorizontalStack verticalAlign="center" align="space-between">
        <HorizontalStack verticalAlign="center">
          <Heading type="heading-6" singleLine>
            {option.title}
          </Heading>
          {!!option.popover && (
            <InfoWithPopover content={option.popover.content} imgSrc={option.popover.imgSrc} />
          )}
        </HorizontalStack>
        <SimpleSelect
          options={adaptedOptions}
          defaultValue={defaultValue}
          onChange={handleSelectChange}
          transparent
          menuWidth="auto"
          noVerticalSpacing
          noHorizontalSpacing
          noSpacingBetweenElements
        />
      </HorizontalStack>
    </Box>
  );
};

SelectOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.array.isRequired,
    type: PropTypes.oneOf(Object.values(optionTypes)).isRequired,
    elementIds: PropTypes.arrayOf(PropTypes.string),
    choices: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    popover: PropTypes.shape({
      content: PropTypes.string,
      imgSrc: PropTypes.string,
    }),
    onChange: PropTypes.func,
  }).isRequired,
  settingId: PropTypes.string.isRequired,
  onUpdateValue: PropTypes.func.isRequired,
};

export default SelectOption;
